import React from 'react';

import cartaz from '../img/MODELO_01_A3_LANDSCAPE.jpg';

const Grants = () => {
    return (
        <section id="privacy" className="section">
            <div className="container content">
                <h1 className="title has-text-primary">Apoios</h1>

                <h2 className="subtitle has-text-primary mt-1 mb-3">PRR - Vouchers para Startups</h2>
                <a className="subtitle" href="https://recuperarportugal.gov.pt/" target="_blank" rel="noreferrer">https://recuperarportugal.gov.pt/</a><br/>
                <img src={cartaz} alt="" className="box mt-2" style={{width: "100%", maxWidth: "800px"}}/>
            </div>
        </section>
    );
}

export default Grants;
